import React from 'react';
import { Descriptions, Typography } from 'antd';
import dayjs from 'dayjs';
import parse from 'html-react-parser';
import styled from 'styled-components';

import { StyledColumn } from '../../components/StyledColumn';
import { StyledRow } from '../../components/StyledRow';
import { AttachmentType } from '../emails/Emails.type';

import { EmailAttachments } from './EmailAttachements';

type EmailDataProps = {
  sentDate: number;
  from: string;
  subject: string;
  body: string;
  attachments: AttachmentType[];
  handleAttachmentDragging?: (id: string) => void;
};

const AttachmentsContainer = styled(StyledColumn)`
  display: flex;
  width: 625px;
`;

const EmailDataContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  width: calc(100% - 625px);
  padding-right: 15px;
`;

export const descriptionLabelStyle = {
  fontSize: '14px',
  color: '#9e9e9e',
  paddingLeft: '5px',
  marginBottom: '-10px',
};

export const descriptionContentStyle = {
  backgroundColor: 'white',
  borderColor: 'rgb(217, 217, 217)',
  padding: '8px 11px',
  overFlowY: 'auto',
};

export const EmailData: React.FC<EmailDataProps & React.HTMLAttributes<HTMLDivElement>> = ({
  sentDate,
  from,
  subject,
  body,
  attachments,
  handleAttachmentDragging,
}) => {
  return (
    <StyledRow gap="0">
      <EmailDataContainer>
        <StyledColumn>
          <Descriptions title="" column={3} layout="vertical">
            <Descriptions.Item
              label="Sent date"
              labelStyle={descriptionLabelStyle}
              contentStyle={{ ...descriptionContentStyle, marginRight: '15px' }}
              span={1}
            >
              <Typography.Text>{dayjs.unix(sentDate).format('YYYY-MM-DD HH:mm')}</Typography.Text>
            </Descriptions.Item>

            <Descriptions.Item
              label="From"
              labelStyle={descriptionLabelStyle}
              contentStyle={descriptionContentStyle}
              span={2}
            >
              <Typography.Text>{from}</Typography.Text>
            </Descriptions.Item>

            <Descriptions.Item
              label="Subject"
              labelStyle={descriptionLabelStyle}
              contentStyle={descriptionContentStyle}
              span={3}
            >
              <Typography.Text>{subject}</Typography.Text>
            </Descriptions.Item>

            <Descriptions.Item
              label="Message"
              labelStyle={descriptionLabelStyle}
              contentStyle={{
                ...descriptionContentStyle,
                display: 'flex',
                flexWrap: 'wrap',
                maxHeight: '400px',
                overflowY: 'scroll',
              }}
            >
              <div>{parse(body)}</div>
            </Descriptions.Item>
          </Descriptions>
        </StyledColumn>
      </EmailDataContainer>

      <AttachmentsContainer style={{ backgroundColor: '#F7FAFC', zIndex: 10 }}>
        <EmailAttachments attachments={attachments} setCvAttachement={handleAttachmentDragging}></EmailAttachments>
      </AttachmentsContainer>
    </StyledRow>
  );
};
